import { useContext } from 'react';
import { ObjectContext } from '@/context/ObjectContext';

export const useObjectContext = () => {
	const context = useContext(ObjectContext);
	if (!context) {
		return {
			clientRow: null,
			insight: null,
			broker: null,
			dealRow: null,
			claim: null,
			relationshipCompany: null,
		};
	}
	return context;
};
